var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"Parent Relation","visible":_vm.visible,"bodyStyle":{ padding: '5px 24px 10px 24px !important', height: '50rem' },"dialogStyle":{ height: '54rem', padding: _vm.padding },"maskClosable":false,"footer":null,"centered":"","destroyOnClose":true,"width":_vm.width},on:{"cancel":_vm.handleCancel}},[_c('a-spin',{attrs:{"tip":"Loading data...","spinning":_vm.loader}},[(_vm.list.length > 0)?_c('a-list',{attrs:{"grid":{
        gutter: 8,
        column: 2
      },"data-source":_vm.list},scopedSlots:_vm._u([{key:"renderItem",fn:function(item, index){return _c('a-list-item',{},[_c('a-card',{attrs:{"id":"takeoffRelation","size":"small","headStyle":{
            'font-weight': 'bold',
            background: '#333333 !important',
            color: '#ffffff !important',
            padding: '0 5px'
          },"bodyStyle":{
            width: '100%',
            height: '46rem',
            overflowY: 'auto',
            overflowX: 'hidden'
          }}},[_c('template',{slot:"title"},[_c('span',{staticClass:"level-title"},[_vm._v("\n              "+_vm._s(item.levelName)+"\n            ")])]),_c('template',{slot:"extra"},[_c('div',[_c('span',{staticClass:"total-cost mr-3"},[_vm._v("\n                "+_vm._s(index > 0
                    ? _vm.formatCurrency(item.totalCost)
                    : _vm.formatCurrency(_vm.calculateLevelTotal(item)))+"\n              ")])])]),_vm._l((item.tiles),function(sheet){return _c('div',{key:sheet.id},[(
                index === 0 &&
                  sheet.takeoffs.filter(function (i) { return i.childTileId === _vm.costDetails.id; })
                    .length > 0
              )?_c('a-card',{staticClass:"mt-1",attrs:{"headStyle":{
                background: '#333333 !important',
                color: '#ffffff !important',
                padding: '5px 5px',
                fontSize: '4px !important'
              },"bodyStyle":{
                width: '100%',
                height: _vm.checkItemCount(item) > 1 ? '20rem' : '42rem',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}},[_c('template',{slot:"title"},[_c('span',{staticClass:"level-title"},[_vm._v("\n                  "+_vm._s(sheet.tileName)+"\n                ")])]),_c('template',{slot:"extra"},[_c('div',[_c('span',{staticClass:"total-cost mr-3"},[_vm._v("\n                    "+_vm._s(_vm.formatCurrency(
                        sheet.takeoffs
                          .filter(function (i) { return i.childTileId === _vm.costDetails.id; })
                          .reduce(function (total, takeoff) {
                            return total + (takeoff.unitCost || 0);
                          }, 0)
                      ))+"\n                  ")])])]),_c('a-card',[_c('div',{staticClass:"right"},[_c('tile-takeoff',{attrs:{"takeoffs":sheet.takeoffs.filter(
                        function (i) { return i.childTileId === _vm.costDetails.id; }
                      ),"columns":_vm.columnDefs,"singleClickEdit":false,"tableHeight":_vm.checkItemCount(item) > 1 ? '18rem' : '40rem'}})],1)])],2):_vm._e(),(index > 0)?_c('a-card',{staticClass:"mt-1",attrs:{"headStyle":{
                background: '#333333 !important',
                color: '#ffffff !important',
                padding: '0px 5px',
                fontSize: '4px !important'
              },"bodyStyle":{
                width: '100%',
                height: '42rem',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}},[_c('template',{slot:"title"},[_c('span',{staticClass:"level-title"},[_vm._v("\n                  "+_vm._s(sheet.tileName)+"\n                ")])]),_c('template',{slot:"extra"},[_c('div',[_c('span',{staticClass:"total-cost mr-3"},[_vm._v("\n                    "+_vm._s(_vm.formatCurrency(
                        sheet.takeoffs
                          .filter(function (i) { return !i.isAdjustmentTakeoff; })
                          .reduce(function (total, takeoff) {
                            return (
                              total +
                              (takeoff.unitCost ? takeoff.unitCost : 0)
                            );
                          }, 0)
                      ))+"\n                  ")])])]),_c('a-card',[_c('div',{staticClass:"right"},[_c('tile-takeoff',{attrs:{"takeoffs":sheet.takeoffs,"columns":_vm.columnDefs,"singleClickEdit":false,"tableHeight":"40rem"}})],1)])],2):_vm._e()],1)})],2)],1)}}],null,false,1330772828)}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }